import {
  Avatar1,
  Avatar2,
  Avatar3,
  Avatar4,
  Avatar5,
  Avatar6,
  Avatar7,
  Avatar8,
  Avatar9,
  Avatar10,
  Avatar11,
  Avatar12,
  Avatar13,
  Avatar14,
  Avatar15,
  Avatar16,
  Avatar17,
  Avatar18,
  Avatar19,
  Avatar20
} from '../../assets/images/avatars';

export const ENUMSAVATARICONS = {
  chin: { img: Avatar1, axis: 'axis1' },
  gato: { img: Avatar2, axis: 'axis1' },
  koala: { img: Avatar3, axis: 'axis1' },
  leon: { img: Avatar4, axis: 'axis1' },
  mono: { img: Avatar5, axis: 'axis1' },
  runner: { img: Avatar6, axis: 'axis1' },
  sirena: { img: Avatar7, axis: 'axis1' },
  surfer: { img: Avatar8, axis: 'axis1' },
  tostadora: { img: Avatar9, axis: 'axis1' },
  rex: { img: Avatar10, axis: 'axis1' },
  tucan: { img: Avatar11, axis: 'axis1' },
  yoga: { img: Avatar12, axis: 'axis1' },
  croisant: { img: Avatar13, axis: 'axis2' },
  donuts: { img: Avatar14, axis: 'axis2' },
  pingu: { img: Avatar15, axis: 'axis2' },
  pulpo: { img: Avatar16, axis: 'axis2' },
  bruja: { img: Avatar17, axis: 'axis3' },
  cangrejo: { img: Avatar18, axis: 'axis3' },
  pez: { img: Avatar19, axis: 'axis3' },
  pinia: { img: Avatar20, axis: 'axis3' }
};

export const selectAvatar = iconId => {
  const { [iconId]: icon } = ENUMSAVATARICONS;
  return icon && icon.img;
};

export const selectAvatarAxis = iconId => {
  const { [iconId]: icon } = ENUMSAVATARICONS;
  return icon && icon.axis;
};

export const getAvatares = () => {
  const avt = Object.keys(ENUMSAVATARICONS);
  const arrayAvatares = [];
  avt.map((avatar, index) =>
    arrayAvatares.push({ ...ENUMSAVATARICONS[avatar], id: avt[index] })
  );
  return arrayAvatares;
};
